<script>
    import _ from 'lodash'
    import ListUtils from '@/utils/list'
    import OrgService from '@/request/user/org'
    // import OrgUserService from '@/request/user/orguser'
    import PatientService from '@/request/patient/patient'
    import RecordService from '@/request/record/record'
    import DiagnosisService from '@/request/dictionary/diagnosis'
    import DoctorService from '@/request/record/doctor'
    export default {
        name: 'RecordEdit',
        props: {
            record: {
                type: Object,
                default () {
                    return {}
                }
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                visibleEditRecord: this.visible,
                hospital: null,
                diagnoseLoading: false,
                diagnoseSelection: [],
                doctorSelection: [],
                orgSelection: [],
                recordSaving: false,
                editRecord: {},
                defaultRecordValue: {
                    oidPath: [],
                    diagnoses: []
                },
                lockBedid: false
            }
        },
        computed: {},
        created: function () {},
        mounted: function () {},
        beforeDestroy () {},
        watch: {
            visible (val) {
                this.visibleEditRecord = val
            },
            record () {
                this.init()
            },
            'editRecord.oidPath': function (val, oldVal) {
                if (_.isUndefined(oldVal)) {
                    return
                }
                this.editRecord.oid = _.last(val) || null
            },
            'editRecord.oid': function () {
                this.loadHospital()
                this.listDoctor()
            },
            'editRecord.bedid': function (newVal, oldVal) {
                if (!newVal) {
                    return
                }
                if (oldVal === newVal) {
                    return
                }
                this.lockBedid = false
            }
        },
        methods: {
            init () {
                this.editRecord = _.cloneDeep(this.record)
                this.editRecord = _.defaultsDeep(_.cloneDeep(this.defaultRecordValue), this.editRecord)
                if (this.editRecord.diagnoseNames) {
                    this.editRecord.diagnoses = _.split(this.editRecord.diagnoseNames, ',')
                }
                if (!_.isEmpty(this.orgSelection)) {
                    let path = ListUtils.findIdFromTree(this.orgSelection, this.editRecord.oid)
                    this.$set(this.editRecord, 'oidPath', _.cloneDeep(path))
                } else {
                    this.listOrg()
                }
            },
            loadHospital () {
                if (!this.editRecord || !this.editRecord.oid) {
                    this.hospital = null
                    return
                }
                let self = this
                OrgService.loadOrg({
                    descendantId: self.editRecord.oid,
                    parentTypeSn: 'lx0001001'
                }).then(data => {
                    if (data.result) {
                        self.hospital = _.cloneDeep(data.result)
                    }
                })
            },
            listOrg () {
                let self = this
                OrgService.listOrg({
                    typeSns: 'lx0001,lx0001001,lx0001001001',
                    descendant: 1,
                    parents: 1
                }).then(res => {
                    let orgs = res.result ? res.result : []
                    self.orgSelection = _.clone(ListUtils.listToTree(orgs))
                    if (this.editRecord.oid && _.isEmpty(this.editRecord.oidPath)) {
                        let path = ListUtils.findIdFromTree(this.orgSelection, this.editRecord.oid)
                        this.$set(this.editRecord, 'oidPath', _.cloneDeep(path))
                    }
                })
            },
            checkBedid () {
                let self = this
                return new Promise((resolve, reject) => {
                    if (self.lockBedid) {
                        resolve()
                        return
                    }
                    if (_.isEmpty(self.hospital)) {
                        resolve()
                        return
                    }
                    if (!self.editRecord.bedid) {
                        resolve()
                        return
                    }
                    if (self.editRecord.bedid === self.record.bedid) {
                        resolve()
                        return
                    }
                    RecordService.count({
                        hospitalized: 1,
                        status: '1,2,3,4,5',
                        hids: self.hospital.id,
                        bedid: self.editRecord.bedid
                    }).then(res => {
                        let data = res.result
                        if (data) {
                            self.$confirm('床位号：' + self.editRecord.bedid + '已经被其它患者占用！如果继续保存，原病历将自动出院！', '提示', {
                                confirmButtonText: '强制出院',
                                cancelButtonText: '更改床号',
                                type: 'warning'
                            }).then(() => {
                                self.$message({
                                    message: '保存后，原[' + self.editRecord.bedid + ']床的病历出院',
                                    type: 'warning'
                                })
                                self.lockBedid = true
                                resolve()
                            }).catch(() => {
                                self.editRecord.bedid = null
                                reject(new Error('输入新床号'))
                            })
                        } else {
                            resolve()
                        }
                    }).catch(() => {
                        resolve()
                    })
                })
            },
            listDoctor () {
                if (!this.editRecord.oid) {
                    this.doctorSelection = []
                    return
                }
                let self = this
                /*OrgUserService.list({
                  oids: self.editRecord.oid
                }).then(res => {
                  let data = res.result ? res.result : []
                  let ds = []
                  _.forEach(data, doctor => {
                    if (_.findIndex(ds, {'uid': doctor.uid}) >= 0) {
                      return
                    }
                    ds.push(doctor)
                  })
                  self.doctorSelection = _.clone(ds)
                })*/
                DoctorService.list({
                    oids: self.record.oid
                }).then(res => {
                    let data = res.result ? res.result : []
                    self.doctorSelection = _.clone(data)
                })
            },
            listDiagnosis (query) {
                let self = this
                self.diagnoseLoading = true
                DiagnosisService.find({
                    pageOffset: 1,
                    pageSize: 100
                }, {
                    match: query || null
                }).then(res => {
                    let data = res.result['content'] || []
                    if (query) {
                        let evens = _.remove(data, item => {
                            return item.name === query
                        })
                        if (!_.isEmpty(evens)) {
                            data = _.concat(evens, data)
                        }
                    }
                    data = _.uniqBy(data, 'name')
                    self.diagnoseSelection = _.cloneDeep(data)
                    self.diagnoseLoading = false
                }, () => {
                    self.diagnoseSelection = []
                    self.diagnoseLoading = false
                })
            },
            handleHistorySnBlur () {
                let self = this
                if (!self.editRecord.historySn || !self.hospital) {
                    return
                }
                PatientService.load({
                    historySn: self.editRecord.historySn,
                    hid: self.hospital.id
                }).then(res => {
                    let data = res.result ? res.result : null
                    if (data) {
                        if (self.editRecord.pat !== data.id) {
                            self.$alert('病历号：' + self.editRecord.historySn + '已经被其它患者使用！', '提示', {
                                confirmButtonText: '确定',
                                callback: () => {
                                    self.editRecord.historySn = null
                                }
                            })
                        }
                    }
                })
            },
            splitDiagnose (names) {
                var patt = new RegExp('([A-Za-z\\u4e00-\\u9fa5]|\\d(?=\\u578b)){1,}?([（\\(][^\\)）\\t\\n\\r\\f]{1,}[\\)）]|([A-Za-z0-9]{1,}[,;，；、/]{1}(?=[A-Za-z0-9])|[A-Za-z0-9]{1,}[_―/\\-]{1}[A-Za-z0-9]{1,}){1,}|[A-Za-z]{0,}[0-9]{1,}(?=[\\u4e00-\\u9fa5])|[A-Za-z°\\u4e00-\\u9fa5\\u2150-\\u218F]){0,}[\\u4e00-\\u9fa5A-Za-z]{0,}', 'g')
                let result = []
                var item = null
                names = [].concat(names)
                _.forEach(names, name => {
                    if (_.isNumber(name)) {
                        result.push(name)
                        return
                    }
                    while ((item = patt.exec(name)) != null) {
                        result.push(item[0])
                    }
                })
                return result
            },
            saveDiagnoses () {
                let self = this
                let promises = []
                let diagnosesIds = []
                let message = self.$message({
                    message: '正在保存诊断信息...',
                    center: true,
                    duration: 0
                })
                return new Promise((resolve, reject) => {
                    if (_.isEmpty(self.editRecord.diagnoses)) {
                        self.editRecord.diagnose = null
                        message.close()
                        resolve()
                        return
                    }
                    let tempDiagnose = self.splitDiagnose(self.editRecord.diagnoses)
                    if (_.join(tempDiagnose) === self.record.diagnoseNames) {
                        message.close()
                        resolve()
                        return
                    }
                    if (!_.isEmpty(tempDiagnose)) {
                        _.forEach(tempDiagnose, value => {
                            if (_.isNumber(value)) {
                                diagnosesIds.push(value)
                            } else {
                                promises.push(DiagnosisService.save({
                                    hid: self.hospital ? self.hospital.id : null,
                                    name: value
                                }))
                            }
                        })
                    }
                    if (_.isEmpty(promises)) {
                        self.editRecord.diagnose = _.join(diagnosesIds)
                        message.close()
                        resolve()
                        return
                    }
                    Promise.all(promises).then(values => {
                        if (_.isEmpty(values)) {
                            self.editRecord.diagnose = _.join(diagnosesIds)
                            message.close()
                            resolve()
                            return
                        }
                        _.forEach(values, value => {
                            let data = value.result
                            if (!data) {
                                return
                            }
                            if (_.indexOf(diagnosesIds, data.id) < 0) {
                                diagnosesIds.push(data.id)
                            }
                        })
                        self.editRecord.diagnose = _.join(diagnosesIds)
                        message.close()
                        resolve()
                    }, err => {
                        message.close()
                        reject(err)
                    })
                })
            },
            saveRecord () {
                let self = this
                let message = this.$message({
                    message: '正在保存病历信息...',
                    center: true,
                    duration: 0
                })
                return new Promise((resolve, reject) => {
                    // 判断修改的字段，如果这些字段没有修改表示病历没有被修改
                    let params = ['oid', 'historySn', 'bedid', 'attending', 'diagnose', 'stateOfAnIllness']
                    let updated = false
                    if (self.record.oid && !self.editRecord.oid) {
                        message.close()
                        reject(new Error('科室不能为空'))
                        return
                    }
                    _.forEach(params, value => {
                        if (self.editRecord[value] !== self.record[value]) {
                            updated = true
                        }
                    })
                    if (!updated) {
                        message.close()
                        resolve(self.editRecord)
                        return
                    }
                    self.$refs['editRecordForm'].validate(valid => {
                        if (valid) {
                            self.checkBedid().then(() => {
                                let _record = _.cloneDeep(self.editRecord)
                                _record.diagnoseNames = null
                                delete _record.oidPath
                                delete _record.diagnoses
                                RecordService.save(_record).then(res => {
                                    let data = res.result || null
                                    if (!data) {
                                        message.close()
                                        reject(new Error('保存病历信息失败'))
                                        return
                                    }
                                    _.assign(self.editRecord, data)
                                    message.close()
                                    resolve(data)
                                }, err => {
                                    message.close()
                                    reject(err)
                                })
                            }).catch(error => {
                                message.close()
                                reject(error)
                            })
                        } else {
                            message.close()
                            reject(new Error('表单验证失败!'))
                        }
                    })
                })
            },
            handleCancelEditRecord () {
                this.editRecord = _.cloneDeep(this.defaultRecordValue)
                this.recordSaving = false
                this.$emit('close')
            },
            submitRecord () {
                let self = this
                self.recordSaving = true
                self.saveDiagnoses().then(() => {
                    self.saveRecord().then(record => {
                        self.$message({
                            message: '病历保存成功',
                            type: 'success'
                        })
                        self.visibleEditRecord = false
                        this.$emit('success', record)
                    }).catch(err => {
                        self.$message.error(err && err.message ? err.message : '保存病历信息失败')
                        this.$emit('error', err)
                    }).finally(() => {
                        self.recordSaving = false
                    })
                }).catch(err => {
                    self.$message.error(err)
                    self.recordSaving = false
                })
            },
            openCascader (val) {
                if (val) {
                    this.$nextTick(() => {
                        const lis = this.$refs.cascader.panel.$el.lastChild.querySelectorAll('li')
                        _.forEach(lis, val => {
                            if (val.className.indexOf('is-active') !== -1) {
                                val.click()
                            }
                        })
                    })
                }
            }
        }
    }
</script>

<template>
    <el-dialog title="编辑病历信息" :visible.sync="visibleEditRecord" @close="handleCancelEditRecord" :close-on-click-modal="false">
        <el-form ref="editRecordForm" label-position="right" label-width="100px" :model="editRecord" :disabled="recordSaving">
            <el-form-item label="科室" prop="oid" v-if="orgSelection.length > 0" :rules="[{ required: true, message: '科室不能为空' }]">
                <el-cascader
                    v-if="visibleEditRecord"
                    ref="cascader"
                    @visible-change="openCascader"
                    :options="orgSelection"
                    :props="{checkStrictly: true, value: 'id', label: 'name', children: 'children'}"
                    :disabled="orgSelection.length === 1"
                    clearable
                    v-model="editRecord.oidPath"
                    style="width: 100%;">
                </el-cascader>
            </el-form-item>
            <el-form-item label="病历号" prop="historySn" :rules="[{ required: true, message: '病历号不能为空' }]">
                <el-input v-model="editRecord.historySn" placeholder="请输入患者病历号" @blur="handleHistorySnBlur"></el-input>
            </el-form-item>
            <el-form-item label="床位号" prop="bedid" v-if="editRecord.hospitalized === 1" :rules="[{ required: true, message: '床号不能为空' }]">
                <el-input v-model="editRecord.bedid" placeholder="请输入住院床号"></el-input>
            </el-form-item>
            <el-form-item label="主治医生" prop="attending">
                <el-select v-model="editRecord.attending" placeholder="请选择主治医生" style="width: 100%;">
                    <el-option
                            v-for="item in doctorSelection"
                            :key="item.id"
                            :label="item.name"
                            :value="item.uid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="诊断" prop="diagnose">
                <el-select
                        v-model="editRecord.diagnoses"
                        clearable
                        multiple
                        filterable
                        remote
                        allow-create
                        default-first-option
                        placeholder="输入关键词查找诊断(支持新建)"
                        :remote-method="listDiagnosis"
                        :loading="diagnoseLoading"
                        @focus="listDiagnosis()"
                        style="width: 100%;">
                    <el-option
                            v-for="item in diagnoseSelection"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="病情描述" prop="stateOfAnIllness">
                <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="editRecord.stateOfAnIllness" placeholder="请输入病情描述"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visibleEditRecord = false">取 消</el-button>
            <el-button type="primary" @click="submitRecord()">确 定</el-button>
        </div>
    </el-dialog>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
